export default {
  paged: {
    select:
      'id,status,billingMode,monthlyFee,currency,billingCycleType,paymentCollectionMode,nextBillingDate,autoRenew',
    searchSelect: ['company/commercialName', 'company/identity', 'automyPlan/name'],
    orderBy: 'company/commercialName asc',
    expand: {
      company: {
        select: 'commercialName,identity',
      },
      automyPlan: {
        select: 'name',
      },
    },
  },
  itemDetail: {
    expand: {
      company: {
        select: 'commercialName,identity',
      },
      automyPlan: {
        select: 'name',
      },
      billingCountry: {
        select: 'code,name',
      },
      defaultPaymentMethod: {
        select: 'methodType',
      },
    },
  },
};
